import { render, staticRenderFns } from "./planeSpin.vue?vue&type=template&id=5c340096&scoped=true&"
import script from "./planeSpin.vue?vue&type=script&lang=js&"
export * from "./planeSpin.vue?vue&type=script&lang=js&"
import style0 from "./planeSpin.vue?vue&type=style&index=0&id=5c340096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c340096",
  null
  
)

export default component.exports